import React from "react";
import { MddDialog, MddDialogButtons } from "../../../common";

interface IMddStudySiteDeleteProtocolConfirmDialogProps {
  open: boolean;
  protocolName: string;
  onConfirm: () => void;
  onClose: () => void;
}

export const MddStudySiteDeleteProtocolConfirmDialog = ({
  open,
  protocolName,
  onConfirm,
  onClose
}: IMddStudySiteDeleteProtocolConfirmDialogProps): JSX.Element => {
  return (
    <MddDialog
      dialogProps={{
        open,
        maxWidth: "sm",
        fullWidth: true
      }}
      dialogTitleProps={{
        title: "Delete Protocol Participation"
      }}
      dialogContentProps={{
        className: "mdd-dialog--content-100percent"
      }}
      dialogContent={
        <div className="mdd-study-site--dialog-content">
          <p className="mdd-study-site--dialog-text">
            Are you sure you want to delete {protocolName} from the Study Site
            Protocol Participation?
          </p>
        </div>
      }
      dialogActions={
        <MddDialogButtons
          saveButtonText="Delete"
          saveButtonProps={{
            onClick: onConfirm
          }}
          closeButtonProps={{
            onClick: onClose
          }}
        />
      }
      showCloseButton
      onCloseClick={onClose}
    />
  );
};
